import { Collapse } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RightCircleFilled, DownCircleFilled } from '@ant-design/icons';

const TableOfContents = ({ contentRef, customTocItems, activeKeys }) => {
  const { t } = useTranslation();

  // Default items if none provided
  const defaultTocItems = [
    { id: 'agronomique', label: t('active-substance-details|Agronomic Information'), href: '#section-agronomique', collapseKey: '1' },
    { id: 'cultures', label: t('active-substance-details|Cultures and Associated Commercial Products'), href: '#section-cultures', collapseKey: '2' },
    { id: 'produits', label: t('active-substance-details|Commercial Products'), href: '#section-products', collapseKey: '3' },
    { id: 'sante', label: t('active-substance-details|Health Risks'), href: '#section-health', collapseKey: '4' },
    { id: 'environnement', label: t('active-substance-details|Environmental Risks'), href: '#section-environnement', collapseKey: '5' }
  ];

  const tocItems = customTocItems || defaultTocItems;

  const activeItemIds = useMemo(() => {
    if (!activeKeys || activeKeys.length === 0) return new Set();
    const keySet = new Set(activeKeys.map(String));
    return new Set(
      tocItems
        .filter((item) => item.collapseKey && keySet.has(String(item.collapseKey)))
        .map((item) => item.id)
    );
  }, [activeKeys, tocItems]);

  const handleClick = (e, itemId) => {
    e.preventDefault();

    const targetId = e.currentTarget.getAttribute('href').substring(1);
    const container = contentRef?.current || document;
    const element = container.querySelector(`#${targetId}`);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const content = (
    <nav aria-label={t('active-substance-details|Table of Contents')}>
      <ol className='content-list'>
        {tocItems.map((item) => (
          <li key={item.id} className={activeItemIds.has(item.id) ? 'active' : ''}>
            <a
              href={item.href}
              className={`flex gap-[14px] items-center ${activeItemIds.has(item.id) ? 'text-[#105235] font-bold' : ''}`}
              onClick={(e) => handleClick(e, item.id)}
            >
              <span className="circle" aria-hidden="true"></span>
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );

  const items = [
    {
      key: '1',
      label: <p className="collapse-nested-title">{t('active-substance-details|Table of Contents')}</p>,
      children: content,
    }
  ];

  return (
    <Collapse
      bordered={false}
      className="table-of-contents"
      items={items}
      defaultActiveKey={['1']}
      expandIcon={({ isActive }) =>
        isActive ? <RightCircleFilled style={{ fontSize: "24px" }} /> : <DownCircleFilled style={{ fontSize: "24px" }} />
      }
    />
  );
};

export default TableOfContents;